export function postUserCheckIn(isLocker, reservationId, longitude, latitude) {
  return this.http.post("/user-check-in", {
    isLocker,
    reservationId,
    longitude,
    latitude,
  });
}
